export default "__VITE_ASSET__DKHPVNnA__"